import { CreateOrderRequest, OrderType, PaymentMethod } from '@models/order';
import { PayloadAction, WritableDraft } from '@reduxjs/toolkit';

export const setNote = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<string>) => {
    state.note = action.payload;
};

export const setPaymentMethod = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<PaymentMethod>) => {
    state.paymentMethod = action.payload;
};

export const setOrderType = (state: WritableDraft<CreateOrderRequest>, action: PayloadAction<OrderType>) => {
    state.orderType = action.payload;
};
